import { Modal } from "@mantine/core";
import { message, Space, Table, Tooltip } from "antd";
import { useEffect, useState } from "react";
import EditLaboratoryForm from "./edit-laboratory";
import smalltalk from 'smalltalk';
import { deleteLaboratory } from "../../../helpers/api";
import { hasPermission } from "../../../helpers/utilities";
import { action, resouces } from "../../../helpers/auth";

const Laboratories = ( { data, onReload, isloading } ) => {
    const [ modal, setModal ] = useState( {
        title: "",
        open: false,
        content: "",
    } );

    const handleDeleteLabs = ( id ) => {
        smalltalk.confirm(
            "Delete Laboratory", "This action cannot be undone. Delete Laboratory?", {
            buttons: {
                ok: 'YES',
                cancel: 'NO',
            },
        }
        ).then( go => {
            deleteLaboratory( id ).then( res => {
                if ( res.status === 204 ) {
                    message.success( 'laboratory deleted' );
                    onReload();
                }
            } );

        } ).catch( ex => {
            // console.log(ex);
            return false;
        } );
    };

    useEffect( () => { }, [ data ] );

    return (
        <div className="row">
            <Modal
                title={ modal.title }
                opened={ modal.open }
                onClose={ () => setModal( { ...modal, open: false } ) }
            >
                { modal.content }
            </Modal>
            <div className="col-12">
                <Table
                    columns={ [
                        {
                            title: "#",
                            sorter: ( a, b ) => a.index > b.index,
                            sortDirections: [ "descend", "ascend" ],
                            render: ( text, record, index ) => ++index,
                            width: '70px'
                        },
                        {
                            title: "Laboratory",
                            dataIndex: 'laboratoryName',
                            sorter: ( a, b ) => a.providerName > b.providerName,
                            sortDirections: [ "descend", "ascend" ],
                        },
                        {
                            title: "Contact Person",
                            dataIndex: 'contactPerson',
                            sorter: ( a, b ) => a.contactPerson > b.contactPerson,
                            sortDirections: [ "descend", "ascend" ],
                        },
                        {
                            title: "Contact",
                            dataIndex: 'contact',
                            sorter: ( a, b ) => a.contact > b.contact,
                            sortDirections: [ "descend", "ascend" ],
                        },
                        // {
                        //     title: "Region",
                        //     dataIndex: 'region',
                        //     sorter: ( a, b ) => a.region > b.region,
                        //     sortDirections: [ "descend", "ascend" ],
                        // },
                        {
                            title: "Consults",
                            dataIndex: 'totalConsultations',
                            sorter: ( a, b ) => a.totalConsultations > b.totalConsultations,
                            sortDirections: [ "descend", "ascend" ],
                        },
                        {
                            title: "Action",
                            render: ( text, record, index ) => (
                                <Space>
                                    <div class="buttons has-addons">
                                        {
                                            hasPermission( resouces.laboratories, action.canUpdate ) &&
                                            <Tooltip title="Edit Laboratory">
                                                <button
                                                    className="d-flex align-items-center button is-small"
                                                    onClick={ () => {
                                                        setModal( {
                                                            title: "Editing Laboratory",
                                                            open: true,
                                                            content: <EditLaboratoryForm laboratoryId={ record.id } onSuccess={ onReload } />,
                                                        } );
                                                    } }>
                                                    <span className="bi bi-pencil"></span>
                                                </button>
                                            </Tooltip>
                                        }
                                        {
                                            hasPermission( resouces.laboratories, action.canDelete ) &&
                                            <Tooltip title="Delete Laboratory">
                                                <button className="button is-small" onClick={ () => handleDeleteLabs( record.id ) }>
                                                    <span className="bi bi-trash"></span>
                                                </button>
                                            </Tooltip>
                                        }
                                    </div>
                                </Space>
                            ),
                        },

                    ] }
                    className="border"
                    dataSource={ data }
                    rowKey={ ( record ) => record.id }
                    loading={ isloading }
                    bordered
                />
            </div>
        </div>
    );
};

export default Laboratories;